import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface AcceptState {
  confirmLater: boolean;
  confirmed: boolean;
  redirectToLogin: boolean;
  cardDesignSelection: boolean;
}

const initialState: AcceptState = {
  confirmLater: false,
  confirmed: false,
  redirectToLogin: false,
  cardDesignSelection: false,
};

const acceptScreenSlice = createSlice({
  name: 'acceptScreen',
  initialState,
  reducers: {
    setConfirmAddressLater: (state, action) => {
      state.confirmLater = action.payload;
    },
    setConfirm: (state, action: PayloadAction<boolean>) => {
      state.confirmed = action.payload;
    },
    setRedirectToLogin: (state, action: PayloadAction<boolean>) => {
      state.redirectToLogin = action.payload;
    },
    setCardDesignSelection: (state, action: PayloadAction<boolean>) => {
      state.cardDesignSelection = action.payload;
    },
  },
});

export const {
  setConfirmAddressLater,
  setConfirm,
  setRedirectToLogin,
  setCardDesignSelection,
} = acceptScreenSlice.actions;
export default acceptScreenSlice.reducer;
